import { useEffect, useState } from "react";
import { Award, Users, Bike, Heart } from "lucide-react";
import { apiClient } from "../lib/api";
import Seo from "../components/Seo";

const SHOW_IMG = "https://images.pexels.com/photos/30396826/pexels-photo-30396826.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1200";

const About = () => {
  const [stats, setStats] = useState({ happy_customers: 500, motorcycles_in_stock: 120, years_experience: 15, brands_count: 30 });

  useEffect(() => {
    apiClient.get("/stats").then(r => setStats(r.data)).catch(() => {});
  }, []);

  return (
    <div data-testid="about-page" className="bg-zinc-950 text-white pt-32 pb-24 min-h-screen">
      <Seo
        title="Hakkımızda"
        description="Gensan Motors, 2020'den beri İstanbul Maltepe'de motor tutkunlarına hizmet veren kurumsal bir motosiklet galerisidir. Sıfır ve ikinci el motor satışı, servis ve finansman çözümleri."
        keywords="Gensan Motors hakkında, motosiklet galerisi İstanbul, Maltepe motor"
        path="/hakkimizda"
      />
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
        <div className="mb-16">
          <div className="flex items-center gap-3 mb-4">
            <span className="block h-px w-12 bg-orange-500" />
            <span className="text-orange-500 font-bold uppercase tracking-[0.3em] text-xs">
              Hakkımızda
            </span>
          </div>
          <h1 className="font-display text-5xl md:text-7xl font-bold uppercase leading-none tracking-tight max-w-4xl">
            Yolun <span className="text-orange-500">Hikayesi</span> Burada Başlar
          </h1>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20 mb-24">
          <div>
            <div className="aspect-[4/5] overflow-hidden">
              <img src={SHOW_IMG} alt="Gensan Showroom" className="w-full h-full object-cover" />
            </div>
          </div>
          <div className="flex flex-col justify-center">
            <h2 className="font-display text-3xl md:text-4xl font-bold uppercase mb-6 tracking-tight">
              Yılların <span className="text-orange-500">Tutkusu</span>
            </h2>
            <p className="text-zinc-300 text-lg leading-relaxed mb-6">
              Gensan Motors, 2020 yılından bu yana İstanbul Maltepe'deki showroom'unda motor tutkunlarına hizmet vermektedir. Geniş stok seçeneklerimiz, uzman ekibimiz ve şeffaf satış politikamızla bugüne kadar binlerce müşterimizi mutlu ettik.
            </p>
            <p className="text-zinc-400 leading-relaxed mb-6">
              Sıfır motosiklet alımından ikinci el ekspertiz desteğine, finansman çözümlerinden servis hizmetlerine kadar tüm ihtiyaçlarınız için tek adres olmayı hedefliyoruz.
            </p>
            <p className="text-zinc-400 leading-relaxed">
              Bizim için motor yalnızca bir araç değil; özgürlüğün, tutkunun ve yaşam tarzının ifadesidir. Bu yüzden müşterilerimize sadece bir motor değil, unutulmaz bir deneyim sunmak için çalışıyoruz.
            </p>
          </div>
        </div>

        {/* Stats */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-px bg-zinc-900 border border-zinc-900">
          {[
            { icon: Award, value: `${stats.years_experience}+`, label: "Yıllık Tecrübe" },
            { icon: Bike, value: `${stats.motorcycles_in_stock}+`, label: "Stoktaki Motor" },
            { icon: Users, value: `${stats.happy_customers}+`, label: "Mutlu Müşteri" },
            { icon: Heart, value: `${stats.brands_count}+`, label: "Marka" },
          ].map((s) => (
            <div key={s.label} className="bg-zinc-950 p-8 text-center">
              <s.icon size={28} className="text-orange-500 mx-auto mb-4" />
              <div className="font-display text-4xl md:text-5xl font-bold mb-2">{s.value}</div>
              <div className="text-xs uppercase tracking-widest text-zinc-500">{s.label}</div>
            </div>
          ))}
        </div>

        {/* Values */}
        <div className="mt-24">
          <h2 className="font-display text-4xl md:text-5xl font-bold uppercase mb-12 tracking-tight">
            BİZİ <span className="text-orange-500">Farklı</span> Kılan
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-px bg-zinc-900 border border-zinc-900">
            {[
              { title: "Şeffaflık", desc: "Her motorun geçmişi, ekspertiz raporu ve fiyatı net bir şekilde paylaşılır." },
              { title: "Güven", desc: "Satış sonrası destek ve garanti hizmetlerimizle her zaman yanınızdayız." },
              { title: "Tutku", desc: "Bizim için bu yalnızca bir iş değil; motor tutkusunu paylaşan bir aileyiz." },
            ].map((v, i) => (
              <div key={v.title} className="bg-zinc-950 p-10">
                <div className="text-orange-500 font-display text-5xl font-bold mb-4">0{i + 1}</div>
                <h3 className="font-display text-2xl font-bold uppercase mb-3 tracking-tight">{v.title}</h3>
                <p className="text-zinc-400 leading-relaxed">{v.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;
